<template>
   <div class="modal-container has-text-centered">
         <div class=" bottom20 top5">
           <div class="has-background-dark pad10"> <div class="is-size-4"><span class=" has-text-white"><img src="@/assets/img/fourDotsLogo.png" width="18"/> <b>UPGRADE TO PRO</b></span></div></div>
        </div>
       <div class="pad10">
            <div>
                <i class="has-text-coolGreen top10 is-size-1 fa fa-check"></i>
            </div>
            <div class="top20"><b>{{message}}</b></div>
            <div class="top20 is-size-4 has-text-coolGreen"><b>Advantages of upgrading:</b></div>
            <div class="top10 is-size-6">
                <ul>
                    <li><b>- Unlimitted miimus</b></li>
                    <li><b>- Unlimitted bundles</b></li>
                    <li><b>- Create collab bundles</b></li>
                    <li><b>- Hide Ads</b></li>
                </ul>
            </div>
            <div class="is-size-3 top20 bottom20"><b>$7.99/month</b></div>
          
    
            <div class="top10"><button class="button is-small is-coolGreen" @click="upgrade">UPGRADE</button>&nbsp;<button class="button is-small" @click="cancel">CANCEL</button></div>
            <br>
       </div>
     
   </div>
</template>


<script>


import { AZEventBus } from '../components/AZEventBus'

export default{
    props: {
       
    },

    components: {
        
    },

    data: function(){
        return {
           message: ""
        }
    },

    mounted: function(){

        var self = this

        if(this.$attrs.limit == 'm')
            this.message = 'You have reached the limit of miimus you can create on a free plan. To add more, please upgrade your plan.'

        if(this.$attrs.limit == 'b')
            this.message = 'You have reached the limit of bundles you can create on a free plan. To add more, please upgrade your plan.'
         if(this.$attrs.limit == 'both')
            this.message = 'You have reached the limit of bundles and miimus you can create on a free plan. To add more, please upgrade your plan.'

        if(this.$attrs.msg == 'collab')
            this.message = 'To enable use of Collab bundles please upgrade your plan.'
        if(this.$attrs.msg == 'ads')
            this.message = 'To enable hiding ads please upgrade your plan.'
    },

    methods: {
        cancel: function(){
            this.$emit('close')
        },

        upgrade: function(){
            this.$router.push('/upgrade')
            this.$emit('close')
        },
      
    }

}
</script>


<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }
</style>